import React from "react";

const suswan_joglekar = () => {
  return (
    <div>
      <h1>Suswan Joglekar</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        The students with sufficient CGPA were shortlisted for the aptitude
        round. The online aptitude round was conducted two weeks prior to the
        Hackathon event.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        There was no actual interview as it was a 12-hour Hackathon
        event(however, there was effectively only 8 hours of time allotted to
        active development). But the discussion with the mentor was “like” an
        interview where the mentor judged the participants based on how much
        they are contributing to the project, along with that your inputs (some
        extra features you would suggest for the project) would be noted and
        improve your chances for selection.{" "}
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        It was an 1 hour online assessment involving 2 coding questions.
        <br />
        Both of the coding questions were of hard difficulty.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        Shortlists were released after about 5 days and a total of 11 students
        were shortlisted for the Hackathon.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        After the shortlist was released, we had about 10 days before the actual
        Hackathon. As I had previously participated in a Corporate Hackathon, I
        had some idea of how the event might take place and what all things
        would be impactful. During that time, I majorly invested my time in
        freshening up web development skills by referring to some online
        resources and my friends’ projects.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        As it was a Hackathon there were no formal interview rounds. However
        I’ll break down the process for simplicity:
        <br />
        1) A total of 25 teams participated (8 members in each team (i.e. 200
        total participants)) in the hackathon. Each team had been assigned one
        of three predecided problem statements. Teams were given 12 hours to
        brainstorm ideas, develop a working prototype, and prepare their
        presentations.
      </p>

      <p>
        2) Each team was assigned a mentor, who continuously monitored the
        team’s effort along with individual participation and contributions
        throughout the event. Mentors also suggested new features and
        improvements, helping teams refine their ideas while evaluating their
        problem-solving and innovation skills.
      </p>

      <p>
        3) After 12 hours of work, all teams presented their solutions to a
        panel of judges. The evaluation was based on innovation, relevance,
        scalability and overall impact of the solution. As it was a &lt;Code for
        Change /&gt; Hackathon, it was also important how your project would
        actually be helpful, even though it might be minimal. In the end, three
        teams were selected as winners.
        <br />
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        Since the selection was based on a hackathon rather than formal
        interviews, the focus was mostly on hands-on, practical skills rather
        than theoretical knowledge. The evaluation looked at how we approached
        and solved the problems, how effectively we implemented our ideas, and
        how we worked together as a team. It also considered how clearly we
        could present our project and communicate our thought process.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />I primarily focused on resources that helped me strengthen both
        technical skills and practical application. Some resources that might
        also help you:
      </p>

      <ul>
        <li>
          Online coding platforms like LeetCode,Codeforces to improve
          problem-solving and algorithmic thinking.{" "}
        </li>
        <li>
          Documentation and tutorials for the technologies and frameworks, such
          as React or Nodejs.{" "}
        </li>
        <li>I also referred to some open-source projects and github repos. </li>
      </ul>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Practicing questions on platforms like LeetCode and Codeforces can
        definitely help you develop problem solving skills. Participating in
        contests on these platforms also helps you improve your time management
        skills (which is crucial for online assessments).
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        Since the selection was based on the hackathon, there weren’t direct
        questions about projects or extracurriculars.{" "}
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />I would suggest focusing on practical problem-solving and
        hands-on experience. Participating in hackathons or building small
        projects can be extremely helpful, as judges and mentors value
        innovation and the ability to implement ideas effectively. It’s also
        important to consider how your solution can create real-world impact,
        even if it’s minimal, since you are judged based on creativity,
        contribution, and practical value, not just theoretical knowledge. Being
        an active and collaborative team member is equally important.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Try to contribute meaningfully to any project you take on. Don’t be
        afraid to try out new things and try to learn from your mistakes :).
        <br />
        <strong>Contact Info </strong>
        <br />
        <strong>Email :</strong> <a href="mailto:suswan.joglekar@gmail.com">suswan.joglekar@gmail.com</a>
      </p>

      <hr />
    </div>
  );
};

export default suswan_joglekar;
